import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { CurrencyService } from 'src/app/shared/service/currency.service';
import { Currency } from 'src/app/shared/models/currency.model';
import { Observable, Subscription } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { NbSelectModule } from '@nebular/theme';
import { EnabledCurrencyPipe } from '../../pipes/enabled-currency.pipe';

@Component({
  selector: 'app-select-currency',
  templateUrl: './select-currency.component.html',
  styleUrls: ['./select-currency.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, NgFor, NbSelectModule, EnabledCurrencyPipe]
})
export class SelectCurrencyComponent implements OnInit, OnDestroy {
  @Output() currency: EventEmitter<Currency[]> = new EventEmitter<Currency[]>();
  @Output() allCurrencies: EventEmitter<Currency[]> = new EventEmitter<Currency[]>();
  @Input() multiple = false;
  @Input() showRial = false;
  @Input() required = true;
  @Input() selectAllExceptIRR = false;
  currencies!: Currency[];
  currencyReqSub!: Subscription;
  emptyCurrency = new Currency();
  selectedCurrencies: Currency[] = [];

  constructor(private currencyService: CurrencyService, private cf: ChangeDetectorRef) {
  }

  selectAll(): void {
    this.selectedCurrencies = this.currencies;
    this.currency.emit(this.selectedCurrencies);
    this.cf.markForCheck();
  }

  deselectAll(): void {
    this.selectedCurrencies = [];
    this.currency.emit(this.selectedCurrencies);
    this.cf.markForCheck();
  }

  ngOnInit(): void {
    this.currencyReqSub = this.currencyService.getCurrencies().subscribe((currencies) => {
      this.currencies = currencies;
      this.allCurrencies.emit(this.currencies);
      for (const currency of this.currencies) {
        if (currency.id === 'BTC' && !this.multiple && this.required) {
          this.selectedCurrencies.push(currency);
          this.currency.emit(this.selectedCurrencies);
          this.cf.markForCheck();
        }
      }
      if (this.selectAllExceptIRR) {
        this.selectedCurrencies = this.currencies.filter((currency) => currency.id !== 'IRR');
        this.currency.emit(this.selectedCurrencies);
        this.cf.markForCheck();
      }
    });
  }

  ngOnDestroy(): void {
    this.currencyReqSub.unsubscribe();
  }
}
